import React from 'react';
import { SeekersPipelineProps } from './types';
import { getSeekersByStage, getStageCount, getStageTitle } from './utils';
import SeekerCard from './SeekerCard';

const SeekersPipelineBoard: React.FC<SeekersPipelineProps> = ({ seekers, onSeekerClick }) => {
  const stages = ['pending_consultation', 'awaiting_package', 'payment_pending', 'active_clients'];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      {stages.map((stage) => (
        <div key={stage} className="bg-[#FFFCEF] border border-[#2C2731] rounded-lg overflow-hidden">
          <div className="px-4 py-3 bg-[#2C2731] border-b border-[#2C2731]">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium text-[#FFFCEF]">{getStageTitle(stage)}</h3>
              <span className="inline-flex items-center justify-center w-6 h-6 text-xs font-medium text-[#2C2731] bg-[#FFFCEF] rounded-full border border-[#2C2731]">
                {getStageCount(seekers, stage)}
              </span>
            </div>
          </div>
          <div className="p-3 space-y-3">
            {getSeekersByStage(seekers, stage).map((seeker) => (
              <SeekerCard 
                key={seeker.id} 
                seeker={seeker} 
                onClick={onSeekerClick}
                showViewDetails={stage === 'active_clients'}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SeekersPipelineBoard;
